import { Component } from '@angular/core';
import { AnyoComponent } from '../../../models/AnyoComponent';
import { MasterdataService } from 'projects/admin/src/app/services/masterdata.service';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { ToastService } from '../../../services/toastr.service';
import { CirclesService } from 'projects/admin/src/app/services/circles.service';
import {
  AnyoS3Buckets,
  FileUtilsService,
} from 'projects/app-core/src/service/fileService';
import { TalksService } from '../../services/talks.service';
import { GenericMasterData } from 'projects/admin/src/app/models/masterDataResponse';
import { CircleExperts } from 'projects/admin/src/app/models/circles/CircleExperts';
import { TalkMode } from '../../models/TalkGridResponse';
import { IAnyoUser } from 'projects/app-core/src/auth/models/IAnyoUser';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { ActivatedRoute, Router } from '@angular/router';
import { AnyoTalk } from '../../models/AnyoTalk';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { lastValueFrom } from 'rxjs';
import { AnyoTalkUpdateRequest } from '../../models/UpdateTalksRequest';
import * as moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-edit-talks',
  templateUrl: './edit-talks.component.html',
  styleUrl: './edit-talks.component.scss',
})
export class EditTalksComponent extends AnyoComponent {
  talksSpinner = false;
  description = '';
  title = '';
  imageFile!: File;

  constructor(
    private masterData: MasterdataService,
    protected override auth: AuthService,
    protected toast: ToastService,
    private circleService: CirclesService,
    private fileUtils: FileUtilsService,
    private talks: TalksService,
    private activatedRoute: ActivatedRoute,
    public utils: UtilsService,
    private router: Router,
  ) {
    super(auth);
  }

  talkMode = Object.values(TalkMode);
  selectedExperts: string[] = [];
  categories: GenericMasterData[] = [];
  experts: CircleExperts[] = [];
  selectedTalkMode: TalkMode = TalkMode.RECURRING;
  selectedCategory = '';
  visible = true;
  talk!: AnyoTalk;
  talkId = '';
  image = '';
  editMode = false;

  frequency: string = '1 1 * * *';
  cron: string = '';
  options = [
    {
      label: 'Every hour',
      value: '0 0-23/1 * * *',
    },
    {
      label: 'Every day at eight',
      value: '0 8 * * *',
    },
    {
      label: 'Every Friday',
      value: '0 0 * * 5',
    },
  ];

  enableEditMode() {
    this.editMode = true;
  }

  setValue(value: string): void {
    this.frequency = value;
  }

  getValue(value: string): void {
    this.cron = value;
  }

  uploadMedia($event: any) {
    const file = $event.target.files[0];
    if (file) {
      this.imageFile = file;
    }
  }

  async updateTalks() {
    this.pageLoading = true;
    const request: AnyoTalkUpdateRequest = {
      title: this.title,
      description: this.description,
      mode: this.selectedTalkMode,
      expertIds: this.selectedExperts,
      frequency: this.frequency,
      visible: this.visible,
      image: this.image,
      categoryId: this.selectedCategory,
      visibleFrom: Number(moment().add(1, 'days').format('x')),
      frequencyText: this.utils.getFrequencyText(this.cron),
    };
    if (this.imageFile) {
      const uuid = uuidv4();
      const uuidWithoutHyphens = uuid.replace(/-/g, '');
      const extension = this.imageFile.name.split('.').pop();
      const filePath = `talks/${uuidWithoutHyphens}.${extension}`;
      const uploadUrl = await lastValueFrom(
        this.fileUtils.generateUploadUrl(
          AnyoS3Buckets.CDN_BUCKET,
          filePath,
          this.imageFile.type,
        ),
      );
      this.toast.showSuccess('Image Uploading');
      await lastValueFrom(
        this.fileUtils.uploadFile(this.imageFile, uploadUrl.url),
      );
      this.toast.showSuccess('Image Uploaded');
      request.image = `https://cdn.anyo.app/${filePath}`;
    }
    this.talks.updateTalks(request, this.talkId).subscribe({
      next: () => {
        this.toast.showSuccess('Successfully Talks Updated');
        this.router.navigate(['/talks']);
        this.pageLoading = false;
      },
      error: (err) => {
        const errorBody = err.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
        this.pageLoading = false;
      },
    });
  }

  getTalksById(id: string) {
    this.talks.getTalk(id).subscribe({
      next: (value) => {
        this.title = value.title;
        this.description = value.description;
        this.selectedExperts = value.expertIds as string[];
        this.visible = value.visible;
        this.selectedTalkMode = value.talkMode;
        this.frequency = value.frequency!;
        this.selectedCategory = value.categoryId;
        this.image = value.image!;
        this.pageLoading = false;
      },
      error: (err) => {
        const errorBody = err.error as IAnyoError;
        this.toast.showAnyoErrorToast(errorBody.description);
        this.pageLoading = false;
      },
    });
  }

  async ready(user?: IAnyoUser | undefined): Promise<void> {
    if (user) {
      const id = this.activatedRoute.snapshot.params['id'];
      this.talkId = id;
      this.pageLoading = true;
      if (id) {
        this.getTalksById(id);
      }
      this.activatedRoute;
      this.circleService.getCircleMasterData().subscribe({
        next: (value) => {
          this.experts = value.circleExperts
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toast.showAnyoErrorToast(errorBody.description);
          this.pageLoading = false;
        },
      });
      this.masterData.masterDataList().subscribe({
        next: (response) => {
          this.categories = response.talksCategories;
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toast.showAnyoErrorToast(errorBody.description);
          this.pageLoading = false;
        },
      });
    }
  }
}
